import { render, staticRenderFns } from "./ComputedParamList.vue?vue&type=template&id=a983f47a"
import script from "./ComputedParamList.vue?vue&type=script&lang=js"
export * from "./ComputedParamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports